import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { AsyncPipe, CommonModule, NgClass, NgIf } from '@angular/common';
import { Observable } from 'rxjs';
import { CategoryAccordionBlockComponent } from '@domgen/dgx-fe-components/category';
import {
  MultipleButtonContentCardComponent,
  PopularLinkListBlockComponent,
} from '@domgen/dgx-fe-components/content';
import { VideoListBlockComponent } from '@self-fix/feature-components';
import {
  GridColumnComponent,
  GridContainerComponent,
  GridRowComponent,
  GridSectionComponent,
} from '@domgen/dgx-fe-components/grid';
import { IconComponent } from '@domgen/dgx-fe-components/icon';
import { ButtonComponent } from '@domgen/dgx-fe-components/button';
import { ENVIRONMENT } from '@domgen/dgx-fe-config';

export interface VideoBlocks {
  popularVideos: {
    title: string;
    body: string;
    videoId: string;
    navigationLink: any;
  }[];
  popularVideosBody: string;
  popularVideosTitle: string;
  popularVideosLink: any;
}
@Component({
  selector: 'homepage',
  standalone: true,
  imports: [
    AsyncPipe,
    GridColumnComponent,
    GridContainerComponent,
    GridRowComponent,
    GridSectionComponent,
    NgClass,
    NgIf,
    CommonModule,
    IconComponent,
    ButtonComponent,
    CategoryAccordionBlockComponent,
    MultipleButtonContentCardComponent,
    PopularLinkListBlockComponent,
    VideoListBlockComponent,
  ],
  templateUrl: './homepage.component.html',
  styleUrls: ['./homepage.component.scss'],
})
export class HomepageComponent {
  @Input() applianceCategoriesTitle$: Observable<string>;
  @Input() applianceCategories$: Observable<
    { label: string; value: string; icon: string }[]
  >;
  @Input() popularVideosBlock$: Observable<VideoBlocks>;
  @Output() categoryClick = new EventEmitter<string[]>();
  constructor(@Inject(ENVIRONMENT) public readonly environment: any) {}
}
